import React, { useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { enable2FA, disable2FA, getMFA, selectMFA, sendEditToken, updateBasicInfo, updatePassowrd } from "../redux/slices/publicSlice";
import { useEffect } from "react";
import { selectMe } from "../redux/slices/generalSlice";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { ToastContainer, toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { formatTime } from "../utils/formatTime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const MyProfile = () => {
  const [planToDelete, setplanToDelete] = useState(0);
  const openUpdateBasicInfoDialog = useRef("");
  const closeUpdateBasicInfoDialog = useRef("");
  const editTokenInput = useRef("");
  const dispatch = useDispatch();
  const [editTokenError, seteditTokenError] = useState(null);
  const mfa = useSelector(selectMFA);
  const me = useSelector(selectMe);
  const navigate = useNavigate();
  const notify = () => toast.success("Updated Successfully");

  useEffect(() => {
    dispatch(getMFA());
  }, []);
  useEffect(() => {
    localStorage.setItem("selectedMenu", "settings");
  }, []);

  const RegisterSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    email: Yup.string().required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      username: me?.username,
      email: me?.email,
    },
    validationSchema: RegisterSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      console.log(values);
      dispatch(
        updateBasicInfo({
          email: values.email,
          username: values.username,
          notify,
        })
      );
      openUpdateBasicInfoDialog.current.click();
      setSubmitting(false);
      //   await dispatch(editPlan(values));
      setSubmitting(true);
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, values, setValues, setErrors } = formik;

  useEffect(() => {
    setValues({
      username: me?.username,
      email: me?.email,
    });
  }, [me]);
  const resetPasswordSchema = Yup.object().shape({
    currentPassword: Yup.string().required("Current Password is required"),
    newPassword: Yup.string().required("New Password is required"),
    confirmnewPass: Yup.string()
      .required("Confirm new password required")
      .test("password-match", "Password must match", function (value) {
        return value === this.parent.newPassword;
      }),
    accept: Yup.boolean()
      .oneOf([true], "You must accept the terms and conditions")
      .required("You must accept the terms and conditions"),
  });

  const resetPasswordFormik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmnewPass: "",
      accept: false,
    },
    validationSchema: resetPasswordSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      console.log(values);

      dispatch(updatePassowrd({ ...values, setErrors, resetForm, navigate, notify }));

      setSubmitting(false);
      //   await dispatch(editPlan(values));
      setSubmitting(true);
    },
  });

  const twoFAFormSchema = Yup.object().shape({
    totp: Yup.string().required("OTP is required"),
  });

  const twoFAForm = useFormik({
    initialValues: {
      totp: "",
    },
    validationSchema: twoFAFormSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      console.log(values);

      dispatch(enable2FA({ ...values, setErrors, resetForm }));
    },
  });

  return (
    <>
      <Helmet>
        <title>My Profile - LightningProxies</title>
      </Helmet>
      <div class="page-body-wrapper text-start">
        <div class="row">
          <div class="col-12">
            <div class="header-title">
              <h1>Account Settings</h1>
              <p>All details about user profile</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="accout-details-form-wrap mt-15">
              <h5>Basic Information</h5>
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div class="form-group">
                    <label for="">User ID</label>
                    <input
                      type="text"
                      placeholder="Enter ID"
                      class="form-control disabled "
                      value={me?.id}
                      disabled
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                  <div class="form-group">
                    <label for="">Username</label>
                    <input
                      type="text"
                      placeholder="Enter Username"
                      class="form-control disabled "
                      value={me?.username}
                      disabled
                      style={{ cursor: "not-allowed" }}
                    />
                    <span
                      className="invalid-feedback text-danger"
                      style={{
                        display: Boolean(touched.username && errors.username) ? "block" : "none",
                      }}
                    >
                      {errors.username}
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="">Email Address</label>
                    <input {...getFieldProps("email")} type="text" placeholder="Enter Address" class="form-control" />
                    <span
                      className="invalid-feedback text-danger"
                      style={{
                        display: Boolean(touched.email && errors.email) ? "block" : "none",
                      }}
                    >
                      {errors.email}
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="">Joined</label>
                    <input
                      type="text"
                      placeholder="Enter date"
                      class="form-control disabled"
                      value={new Date(me?.createdAt).toLocaleString("en-US", {
                        month: "short",
                        year: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone: "UTC",
                        timeZoneName: "short",
                      })}
                      disabled
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                  <div class="form-submit justify-content-end">
                    <button type="submit" style={{ background: "#1675FF" }} class="btn btn-submit fs-6 fw-semibold">
                      Update Information <i class="fa fa-angle-right ms-1"></i>
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
            <div class="accout-details-form-wrap mt-15">
              <h5>Change Password</h5>
              <FormikProvider value={resetPasswordFormik}>
                <Form autoComplete="off" noValidate onSubmit={resetPasswordFormik.handleSubmit}>
                  <div class="form-group">
                    <label for="">Current Password</label>
                    <input
                      type="password"
                      placeholder="************************"
                      class="form-control"
                      {...resetPasswordFormik.getFieldProps("currentPassword")}
                    />
                    <span
                      className="invalid-feedback text-danger"
                      style={{
                        display: Boolean(resetPasswordFormik.touched.currentPassword && resetPasswordFormik.errors.currentPassword)
                          ? "block"
                          : "none",
                      }}
                    >
                      {resetPasswordFormik.errors.currentPassword}
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="">New Password</label>
                    <input
                      {...resetPasswordFormik.getFieldProps("newPassword")}
                      type="password"
                      placeholder="************************"
                      class="form-control"
                    />
                    <span
                      className="invalid-feedback text-danger"
                      style={{
                        display: Boolean(resetPasswordFormik.touched.newPassword && resetPasswordFormik.errors.newPassword)
                          ? "block"
                          : "none",
                      }}
                    >
                      {resetPasswordFormik.errors.newPassword}
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="">Confirm New Password</label>
                    <input
                      {...resetPasswordFormik.getFieldProps("confirmnewPass")}
                      type="password"
                      placeholder="************************"
                      class="form-control"
                    />
                    <span
                      className="invalid-feedback text-danger"
                      style={{
                        display: Boolean(resetPasswordFormik.touched.confirmnewPass && resetPasswordFormik.errors.confirmnewPass)
                          ? "block"
                          : "none",
                      }}
                    >
                      {resetPasswordFormik.errors.confirmnewPass}
                    </span>
                  </div>
                  <div class="form-submit d-flex flex-wrap justify-content-between">
                    <div className="form-group">
                      <div class="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="pass"
                          {...resetPasswordFormik.getFieldProps("accept")}
                        />
                        <label
                          style={{ fontSize: "0.875rem" }}
                          className="text-nowrap text-md-wrap text-black text-opacity-75 "
                          for="pass"
                        >
                          I agree to change my password.
                        </label>
                      </div>
                    </div>
                    <div class="form-group ">
                      <button type="submit" style={{ background: "#1675FF" }} class="btn btn-submit fs-6 fw-semibold">
                        Reset Password <i class="fa fa-angle-right ms-1"></i>
                      </button>
                    </div>
                  </div>
                  <span
                    className="invalid-feedback text-danger"
                    style={{
                      display: Boolean(resetPasswordFormik.touched.accept && resetPasswordFormik.errors.accept) ? "block" : "none",
                    }}
                  >
                    {resetPasswordFormik.errors.accept}
                  </span>
                  {/* Errors from server */}
                  {resetPasswordFormik.errors.afterSubmit && (
                    <div className="alert alert-danger my-2" role="alert">
                      {resetPasswordFormik.errors.afterSubmit}
                    </div>
                  )}
                </Form>
              </FormikProvider>
            </div>
          </div>

          <div class=" col-lg-8">
            <div className={"tow-factor-auth-box mt-15 " + (me?.twoFactorEnabled ? "border border-success" : "border border-danger")}>
              <div class="header">
                <p>Two Factor Authentication</p>
                <span> {me?.twoFactorEnabled ? "Enabled" : "Disabled"}</span>
              </div>
              <div id="account-hr-b" className="mx-4 d-none d-lg-block"></div>

              {!me?.twoFactorEnabled && (
                <FormikProvider value={twoFAForm}>
                  <Form autoComplete="off" noValidate onSubmit={twoFAForm.handleSubmit}>
                    <div class="media d-flex flex-column flex-lg-row">
                      {mfa && (
                        <div className="d-flex flex-row">
                          <div>
                            <div
                              style={{
                                height: "auto",
                                margin: "0 auto",
                                maxWidth: 180,
                                width: "100%",
                              }}
                              className="mb-2"
                            >
                              <QRCode
                                size={256}
                                style={{
                                  height: "auto",
                                  maxWidth: "100%",
                                  width: "100%",
                                }}
                                value={mfa?.mfaURL}
                                viewBox={`0 0 256 256`}
                              />
                            </div>
                            <p>{mfa?.mfaSecret}</p>
                          </div>
                          <div id="account-hr-e" className="mx-4 d-none d-lg-block"></div>
                        </div>
                      )}
                      <div class="media-body text-wrap">
                        <h6>
                          To activate 2FA scan this barcode with your Google Authenticator or Authy app on your smartphone. (Or if you
                          are not able to use a camera, enter code manually.) After getting the one-time token enter it in the box
                          below and click Activate.
                        </h6>

                        <form action="">
                          <div class="form-group">
                            <label for="">OTP</label>

                            <div class="d-flex flex-wrap align-items-center justify-content-between">
                              <input
                                style={{ border: "1px solid rgba(255, 255, 255, 0.1)", background: "rgba(255, 255, 255, 0)" }}
                                type="text"
                                placeholder="Enter OTP"
                                class="form-control d-dark col-12 col-md-8  "
                                {...twoFAForm.getFieldProps("totp")}
                              />
                              <input
                                type="text"
                                placeholder="Enter OTP"
                                class="form-control d-light col-12 col-md-8 d-inline-flex justify-content-center flex-fill mt-1"
                                {...twoFAForm.getFieldProps("totp")}
                              />

                              <button
                                onClick={() => {
                                  twoFAForm.handleSubmit();
                                }}
                                type="button"
                                style={{ background: "#1675FF", minWidth: "8rem" }}
                                class="btn btn-submit fs-6 fw-semibold text-nowrap text-white text-center col-12 col-md-4 mt-2 mt-md-1 d-inline-flex justify-content-center flex-fill "
                              >
                                Enable 2FA <i class="fa fa-angle-right ms-1"></i>
                              </button>
                            </div>
                            <span
                              className="invalid-feedback text-danger my-2"
                              style={{
                                display: Boolean(twoFAForm.touched.totp && twoFAForm.errors.totp) ? "block" : "none",
                              }}
                            >
                              {twoFAForm.errors.totp}
                            </span>
                            {/* Errors from server */}
                            {twoFAForm.errors.afterSubmit && (
                              <div className="alert alert-danger my-2" role="alert">
                                {twoFAForm.errors.afterSubmit}
                              </div>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </Form>
                </FormikProvider>
              )}
            </div>
            <div class="accout-details-form-wrap mt-15">
              <h5>API KEY</h5>
              <div class="form-group">
                    <input
                      type="text"
                      placeholder="Enter ID"
                      class="form-control disabled "
                      value={me?.xApiKey}
                      disabled
                      style={{ cursor: "not-allowed" }}
                    />
                    <span
                      className="invalid-feedback text-danger"
                      style={{
                        display: Boolean(touched.username && errors.username) ? "block" : "none",
                      }}
                    >
                      {errors.username}
                    </span>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default MyProfile;
